import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Search, Truck, FileText, ShieldCheck, Umbrella, ClipboardCheck, Wrench, Settings, Star } from "lucide-react";
import api from "@/lib/api";
import { useSettings } from "@/lib/settings";

const SVC_BG = "https://images.unsplash.com/photo-1570720903313-2725e963ad85?w=1920&q=80";
const ICONS = { search: Search, truck: Truck, "file-text": FileText, "shield-check": ShieldCheck, umbrella: Umbrella, "clipboard-check": ClipboardCheck, wrench: Wrench, settings: Settings };

export default function ServicesPage() {
    const [services, setServices] = useState([]);
    const settings = useSettings();
    useEffect(() => {
        api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    }, []);

    return (
        <>
        <title>Услуги | AutoTreider</title>
        <meta name="description" content={`${settings?.services_title || "Услуги"} по подбору, доставке и оформлению автомобилей из Европы.`} />
        <link rel="canonical" href="https://autotreider.eu/services" />
        <meta property="og:title" content={`${settings?.services_title || "Услуги"} | ${settings?.company_name || "AutoTreider"}`} />
        <meta property="og:description" content={`${settings?.services_title || "Услуги"} по подбору автомобилей из Европы.`} />
        <meta property="og:url" content="https://autotreider.eu/services" />
        <div className="min-h-screen pt-16 sm:pt-20" data-testid="services-page">
            <section className="relative h-[30vh] sm:h-[40vh] flex items-center">
                <div className="absolute inset-0"><img src={SVC_BG} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-black/70" /></div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
                    <p className="text-[#0099FF] text-xs uppercase tracking-[0.3em] mb-2 sm:mb-3 font-body">{settings?.services_subtitle || "Услуги"}</p>
                    <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white font-display">{settings?.services_title || "Наши услуги"}</h1>
                </div>
            </section>
            <section className="py-12 sm:py-24" data-testid="services-grid">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {services.map((svc, i) => {
                        const Icon = ICONS[svc.icon] || Star;
                        return (
                            <motion.div key={svc.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-[#09090b] border border-white/5 p-8 hover:border-[#0099FF]/30 transition-all group" data-testid={`service-card-${svc.id}`}>
                                <Icon className="w-10 h-10 text-[#0099FF] mb-6 group-hover:scale-110 transition-transform" strokeWidth={1.5} />
                                <h3 className="text-white font-semibold text-lg mb-3 font-body">{svc.title}</h3>
                                <p className="text-zinc-500 text-sm leading-relaxed font-body">{svc.description}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </section>
        </div>
        </>
    );
}
